<template>
	<div>
		<form v-if="form_data && items" @submit.prevent="sendFormData">
			<div class="form-group">
				<h3>Tevékenység időpontja</h3>
				<label class="form-label">Ez az engedély a következő dátumtól érvényes:</label>
				<div class="row">
					<div class="col-md-8">
						<div class="form-group mt-2">
							<input type="date" class="form-control border-warning" v-model="start_date" :min="now">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group mt-2">
							<input v-if="form_data.with_time" type="time" class="form-control border-warning" v-model="start_time">
						</div>
					</div>
				</div>
				<label class="form-label">Ez az engedély a következő dátumig érvényes:</label>
				<div class="row">
					<div class="col-md-8">
						<div class="form-group mt-2">
							<input type="date" class="form-control border-warning" v-model="end_date" :min="now">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group mt-2">
							<input v-if="form_data.with_time" type="time" class="form-control border-warning" v-model="end_time">
						</div>
					</div>
				</div>
				<div class="form-check mt-2">
					<input class="form-check-input" :true-value="false" :false-value="true" type="checkbox" v-model="form_data.with_time" id="with_time_input" />
					<label class="form-check-label" for="with_time_input">Egész nap</label>
				</div>
			</div>
			<div class="form-group mt-2">
				<h3>Tevékenység helye</h3>
				<table class="table table-bordered">
					<thead>
					</thead>
					<tbody>
					<tr>
						<th>Üzemegység megnevezése</th>
						<td>{{locationslinear.find(l=> l.id == task.location_id) ? locationslinear.find(l=> l.id == task.location_id).name : ''}}</td>
					</tr>
					<tr>
						<th class="align-middle">
							Pontos helyszíne üzemegységen belül							
						</th>
						<td>
							<input type="text" class="form-control border-warning" v-model="form_data.exact_place">
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="form-group">
				<h3>Tevékenység, munka leírása</h3>
				<textarea rows="5" class="form-control border-warning mb-2" v-model="form_data.work_description"></textarea>
				<div v-if="task.description">
					<h3>Kiegészítő információk:</h3>
					<div class="d-block my-4">{{ task.description }}</div>
				</div>
				
			</div>
			<div class="form-group">
				<h3>A munka közben megtartandó tűzvédelmi előírások, készenlétben tartott tűzvédelmi eszközök, megelőző és egyéb intézkedések</h3>
				<div v-for="(item,id) in items" :key="id">
					<div class="input-group mb-1">
						<span class="input-group-text">
							<input type="checkbox" class="form-check-input" v-model="form_data.items[item.id].value">
						</span>
						<span class="input-group-text bg-white">
							{{item.name}}
						</span>
						<input v-if="item.with_text" type="text" v-model="form_data.items[item.id].text" class="form-control">
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import Task from "../../apis/Task";
	import moment from 'moment';
	import Confirmation from "../../apis/Confirmation";
export default {
	props:{permit_type: Object, task: Object},
	data() {
		return {
			form_data:{
				items:[
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
					{value: false,text:""},
				],
				location:this.task.location_id,
				with_time:false,
			},
			items :false,
			completition_items :false,
			start_date:null,
			start_time:null,
			end_date:null,
			end_time:null,
			now:moment().format('YYYY-MM-DD')
		}
	},
	computed:{
		is_complete(){
			if(this.completition_items.filter(ci => ci.satisfied == false).length == 0 && this.datetime_complete){
				return true;
			}else{
				return false;
			}
		},
		datetime_complete(){
			if(this.start_date && this.end_date){
				if(this.form_data.with_time){
					if(this.start_time && this.end_time){
						return true;
					}else{
						return false;
					}
				}else{
					return true;
				}
			}else{
				return false;
			}
		},
		locationslinear() {
            return this.$store.state.locationslinear.filter(d => d.partner_id == null);
        },
	},
	watch: {
		form_data : {
			handler(){
				this.completition_items.forEach( ci => {
					switch(ci.type){
						case 1:
							if(this.form_data[ci.name].filter(i => i.value == true).length >= 1){
								this.$set(ci,'satisfied',true);
							}else{
								this.$set(ci,'satisfied',false);
							}
							break;
						case 2:
							if(this.form_data[ci.name]){
								this.$set(ci,'satisfied',true);
							}else{
								this.$set(ci,'satisfied',false);
							}
							break;
					}
				})
			},
			deep: true
		}
	},
	created() {
		if(this.permit_type.form_data){
			this.form_data = this.permit_type.form_data;
		}
		if(this.permit_type.start_date_time){
			let start_moment = moment(this.permit_type.start_date_time);
			this.start_date = start_moment.format('YYYY-MM-DD');
			this.start_time = start_moment.format('HH:mm');
		}
		if(this.permit_type.end_date_time){
			let end_moment = moment(this.permit_type.end_date_time);
			this.end_date = end_moment.format('YYYY-MM-DD');
			this.end_time = end_moment.format('HH:mm');
		}
		this.items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).items;
		this.completition_items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).completition_items;
	},
	methods:{
		sendFormData(){
			if(!this.is_complete){
				Confirmation.swalCustomConfirm("Hiányos kitöltés","Mentés mindenképp","Így az engedély nem lesz kitöltött állapotú, a mégsem gombra kattintva folytathatod a kitöltést")
				.then(response => {
					if(response.isConfirmed === true){
						this.submitForm();
					}else{
						this.$emit('loadingstop');
					}
				});
			}else{
				this.submitForm();
			}
		},
		submitForm(){
			let start_date_time = this.start_date ? moment(this.start_date+((this.start_time && this.form_data.with_time) ? ' '+this.start_time : ' 00:00')).tz('Europe/Budapest').format() : this.start_date;
			let end_date_time = this.end_date ? moment(this.end_date+((this.end_time && this.form_data.with_time) ? ' '+this.end_time : ' 23:59')).tz('Europe/Budapest').format() : this.end_date;
			Task.sendPermitForm(this.task.id,this.permit_type.id,{form_data:this.form_data, is_complete:this.is_complete, start_date_time: start_date_time, end_date_time:end_date_time})
			.then(() => {
				this.$emit('closemodal','fill_detail_'+this.permit_type.id);
				this.$emit('iscomplete',this.is_complete);
				this.$emit('formdata',{
					form_data: this.form_data,
					start_date_time: start_date_time,
					end_date_time: end_date_time,
				});
			});
		}
	}
}
</script>